import { render, staticRenderFns } from "./CMSettingPage.vue?vue&type=template&id=b1716f66&"
import script from "./CMSettingPage.vue?vue&type=script&lang=js&"
export * from "./CMSettingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1716f66')) {
      api.createRecord('b1716f66', component.options)
    } else {
      api.reload('b1716f66', component.options)
    }
    module.hot.accept("./CMSettingPage.vue?vue&type=template&id=b1716f66&", function () {
      api.rerender('b1716f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/CMSettingPage.vue"
export default component.exports